import { $, GraphQLTypes, InputType, Selector } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';

const validateAnswerSelector = Selector('ValidatedAnswer')({
  correctAnswerId: true,
  level: true,
  tracking: {
    id: true,
    position: true,
    isCompleted: true,
    finalScore: true,
  },
  turn: true,
});

export const answerSelector = Selector('PartialAnswer')({
  id: true,
  text: true,
});

export const GQL_VALIDATE_ANSWER = typedGql('mutation')({
  validateAnswer: [
    { validateAnswerInput: $('validateAnswerInput', 'ValidateAnswerInput!') },
    validateAnswerSelector,
  ],
});

export type StoredValidateAnswer = InputType<
  GraphQLTypes['ValidatedAnswer'],
  typeof validateAnswerSelector
>;

export type StoredAnswer = InputType<
  GraphQLTypes['PartialAnswer'],
  typeof answerSelector
>;
